import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { fetchTherapistReviews } from "../api/admin";
import { formatDateShort } from "../lib/format";
import { StarDisplay } from "./rating";
import { Button, ErrorState, Spinner } from "./ui";

/**
 * Daftar ulasan pasien (bintang 1–5) untuk satu terapis.
 * Data dimuat hanya saat panel dibuka agar halaman admin tetap ringan.
 */
export function TherapistReviewsPanel({
  therapistId,
  count,
}: {
  therapistId: string;
  count: number;
}) {
  const [open, setOpen] = useState(false);
  const reviewsQuery = useQuery({
    queryKey: ["admin", "therapist-reviews", therapistId],
    queryFn: () => fetchTherapistReviews(therapistId),
    enabled: open,
  });

  return (
    <div style={{ marginTop: 8 }}>
      <Button variant="ghost" onClick={() => setOpen((v) => !v)}>
        {open ? "Tutup ulasan" : `Lihat ulasan (${count})`}
      </Button>
      {open ? (
        reviewsQuery.isPending ? (
          <Spinner />
        ) : reviewsQuery.isError ? (
          <ErrorState onRetry={() => void reviewsQuery.refetch()} />
        ) : (reviewsQuery.data ?? []).length === 0 ? (
          <p className="state-hint">Belum ada ulasan dari pasien.</p>
        ) : (
          <div>
            {(reviewsQuery.data ?? []).map((review) => (
              <div key={review.id} className="review-item">
                <StarDisplay rating={review.rating} label={review.patientName} />
                <span className="meta">
                  {formatDateShort(review.bookingDate)} · {review.bookingCode}
                </span>
                {review.comment ? <p className="comment">{review.comment}</p> : null}
              </div>
            ))}
          </div>
        )
      ) : null}
    </div>
  );
}
